// 一些老卡片的消息类型和卡片类型不一致，某些场景为了兼容新老卡片，需要对老卡片做映射
// 此map即这些老卡片的卡片类型到消息类型的映射
export default {
  // 名片卡片
  '1': 57,
  // 公司卡片
  '2': 55,
  // 产品卡片
  '3': 54,
  // 信保条款卡片
  '4': 58,
  // 行为卡片
  '5': 56,
  // 询盘卡片
  '6': 50,
  // 报价卡片, 7&8都是报价卡片
  '7': 52,
  '8': 52,
  // 信保卡片, 9&11都是信保卡片
  '9': 59,
  '11': 59,
  // 文件卡片
  '10': 53,
  // 云盘文件卡片
  '12': 61,
  // 云盘图片卡片
  '13': 60,
  // 云盘视频卡片
  '14': 62,
  // 富文本卡片
  '20': 63
}
